<template>
  <!-- BEGIN FOOTER -->
  <div class="footer-wrapper" style="display: none">
    <div class="footer-section f-section-1">
      <p class="foot-p">Copyright © 2016-{{ year }} kiwi 开为科技版权所有</p>
    </div>
  </div>
  <!-- END FOOTER -->
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.foot-p {
  color: rgba($color: #a1acb3, $alpha: 0.8) !important;
  font-size: 10px !important;
}
</style>